export default "__VITE_ASSET__DfFnJZs9__"